import React from "react";
import parse from 'html-react-parser';

import Accordion from "react-bootstrap/Accordion";

const BillCard = ({ bill }) => {
  return (
    <div className="bill-card">
      <div className="d-flex align-items-center gap-3 mb-1">
        <h2 className="mb-0">{bill.bill_number} in the 114th session of the Tennessee General Assembly</h2>
        {bill.impactScore != null && (
          <span
            className="badge rounded-pill fs-6"
            style={{
              background: bill.impactScore >= 8 ? '#dc3545' : bill.impactScore >= 5 ? '#fd7e14' : '#6c757d',
              whiteSpace: 'nowrap'
            }}
            title="Day-to-day impact score (1–10)"
          >
            Impact {bill.impactScore}/10
          </span>
        )}
      </div>
      <p className="mb-1"><strong>Description:</strong> {bill.description}</p>
      <h6 className="mb-1">Sponsored by: {bill.sponsor}</h6>
      <div className="mb-3 d-flex gap-3">
        <a
          href={`https://capitol.tn.gov/Bills/114/Bill/${bill.bill_number}.pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View House Bill (PDF)
        </a>
        {bill.companionBill && (
          <a
            href={`https://wapp.capitol.tn.gov/apps/BillInfo/Default.aspx?BillNumber=${bill.companionBill}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Senate Companion ({bill.companionBill})
          </a>
        )}
      </div>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
            <Accordion.Header>Explanation/Summary</Accordion.Header>
            <Accordion.Body>
              <div style={{ textIndent: '1rem' }}>{parse(bill.summary)}</div>
            </Accordion.Body>
          </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>ELI5 (Explain like I am 5)</Accordion.Header>
          <Accordion.Body>
            <div style={{ textIndent: '1rem' }}>{parse(bill.layman_summary)}</div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>Impact on Citizens and the State</Accordion.Header>
          <Accordion.Body>
            <div style={{ textIndent: '1rem' }}>{parse(bill.impact_analysis)}</div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default BillCard;
